import { GuideSection, GuideSteps, GuideTip, OnScreen } from '@databink/web/extension';

/** `app.help`: Acme's own way of working, beside the core's guides. */
export function SurveysGuide() {
  return (
    <>
      <GuideSection title="Every installation is surveyed first">
        <p>
          An opportunity in the installations pipeline can’t be marked won until a site survey on it
          is completed. The survey records the heat loss and the system we recommend, which the
          quote is built from.
        </p>
      </GuideSection>
      <GuideSection title="Booking and completing a survey">
        <GuideSteps>
          <li>
            Open the installation opportunity and go to its <OnScreen>Site surveys</OnScreen> tab.
          </li>
          <li>
            Click <OnScreen>Book a survey</OnScreen>, enter the site address and the date, and
            create it. The customer is filled in from the opportunity.
          </li>
          <li>
            After the visit, open the survey, click <OnScreen>Edit</OnScreen>, fill in{' '}
            <OnScreen>Heat loss (kW)</OnScreen> and <OnScreen>Recommended system</OnScreen> and
            click <OnScreen>Save changes</OnScreen>. Then click <OnScreen>Complete survey</OnScreen>
            .
          </li>
        </GuideSteps>
        <GuideTip>
          Upcoming surveys are listed on the home screen, soonest first, so the week’s visits are in
          one place.
        </GuideTip>
      </GuideSection>
    </>
  );
}
